import {easing} from '@helpers/easing'
import {Component} from 'lowkey-component'

const DEFAULT_FRICTION = 2

export class HorizontalScroll extends Component {

  observer: IntersectionObserver | null = null
  friction = DEFAULT_FRICTION
  label: HTMLParagraphElement | undefined = undefined

  constructor(element: HTMLDivElement) {
    super(element)
    this.onIntersection = this.onIntersection.bind(this)
    this.onScroll = this.onScroll.bind(this)
  }

  didMount() {
    if (this.element) {

      this.label = this.element.querySelector('p') as HTMLParagraphElement

      this.label.style.transition = `transform 0.5s ${easing.easeOutQuad}`
      this.label.style.whiteSpace = 'nowrap'

      const {friction} = this.element.dataset
      this.friction = Number(friction) || DEFAULT_FRICTION

      this.observer = new IntersectionObserver(this.onIntersection, {
        rootMargin: '0px',
        threshold: [0, 1],
      })
      this.observer.observe(this.element)
    }
  }

  didUnmount() {
    this.observer?.disconnect()
    window.removeEventListener('scroll', this.onScroll)
  }

  onIntersection(entries: IntersectionObserverEntry[]) {
    for (const entry of entries) {
      // if (!entry.rootBounds) return
      const isDisabled = entry.intersectionRatio < 1
      if (isDisabled && !entry.isIntersecting) {
        window.removeEventListener('scroll', this.onScroll)
      } else {
        window.addEventListener('scroll', this.onScroll)
      }
    }
  }

  onScroll() {
    const {innerHeight} = window
    const {top = 0, height = 0} = this.element?.getBoundingClientRect() || {}
    const {width = 0, height: labelHeight = 0} = this.label?.getBoundingClientRect() || {}
    const max = innerHeight + height
    const pos = innerHeight - top
    const per = (pos / max)
    // const y = Math.floor(innerHeight / this.friction * per)
    const y = Math.floor((width - window.innerWidth + 200 + labelHeight) * per)
    if (this.label) {
      this.label.style.transform = `translateX(${-y}px)`
    }
    // anime({
    //   duration: 500,
    //   easing: 'easeOutSine',
    //   targets: this.label,
    //   translateX: -y,
    // })
  }
}
